<template>
<div class="chapter">
<div class="inner_page">
<div class="fmpage" id="Map">
<h1 class="fmtitle"><a href="#/text/9780062295552_Contents#Map">Map</a></h1>
<p class="image"><img alt="image" class="epubimage" src="images/map.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062295552__Map.vue?57ad3718